import i18n from "../../../public/i18n";

export const isEmailValid = (email) => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  return emailRegex.test(email);
};

export const isCodiceFiscaleValid = (cf) => {
  if (!cf) return "Il codice fiscale è vuoto.";

  cf = cf.toUpperCase().trim();

  if (cf.length !== 16) {
    return "Il codice fiscale deve essere lungo esattamente 16 caratteri.";
  }

  const validChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  if (![...cf].every((char) => validChars.includes(char))) {
    return "Il codice fiscale contiene caratteri non validi.";
  }

  const oddChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const evenChars = "BAKPLCQDREVOSFTGUHMINJWZYX";

  let sum = 0;

  // Calcolo per i primi 15 caratteri del codice fiscale
  for (let i = 0; i < 15; i++) {
    const char = cf[i];
    const isEven = i % 2 === 1;

    let charValue;
    if (char >= "A" && char <= "Z") {
      charValue = char.charCodeAt(0) - "A".charCodeAt(0); // A=0, B=1, ..., Z=25
      charValue = isEven ? evenChars[charValue] : oddChars[charValue];
    } else if (char >= "0" && char <= "9") {
      charValue = parseInt(char, 10); // Valore numerico per le cifre
    }

    sum += isEven ? evenChars.indexOf(charValue) : oddChars.indexOf(charValue);
  }

  // Calcoliamo il carattere di controllo
  const checkChar = String.fromCharCode("A".charCodeAt(0) + (sum % 26));

  if (checkChar !== cf[15]) {
    return "Il codice fiscale non è corretto: il codice di controllo non corrisponde.";
  }

  return ""; // Se tutto è corretto, ritorna una stringa vuota
};

export const arePasswordsEqual = (pwd1, pwd2) => {
  return pwd1 === pwd2;
};

export const validateFiscalCode = (
  value,
  document,
  fiscalCodes,
  userIsDichCongiunta
) => {
  const uppercasedValue = value?.toUpperCase();
  let message = {};
  if (!isCodiceFiscaleValid(uppercasedValue))
    return {
      text: i18n.t("InsertValidCF") + " ✖",
      positive: false,
      alert: false,
    };
  if (uppercasedValue === document?.fiscalCodeUser?.toUpperCase())
    return {
      text: i18n.t("Il CF coincide con quello dell'utente ✔"),
      positive: true,
      alert: false,
    };
  else {
    const fiscalCodesUpperCase = fiscalCodes?.Data?.map((e) =>
      e?.toUpperCase()
    );
    fiscalCodesUpperCase?.includes(uppercasedValue) ? userIsDichCongiunta
      ? (message = {
        text: i18n.t("Il CF appartiene ad un membro della famiglia ✔"),
        positive: true,
        alert: false,
      })
      : (message = {
        text: i18n.t("Il CF non è incluso nella dichiarazione congiunta") + " ✖,",
        positive: false,
        alert: true,
      })
      : (message = {
        text: i18n.t("InconsistentCF") + " ✖,",
        positive: false,
        alert: true,
      })
  }
  return message;
};
